import FieldsOptionsSimpleForm from './FieldsOptionsSimpleForm'

export default FieldsOptionsSimpleForm
